/*
 * @Author: chenmengyao
 */
import store from "@/store";
export const option = {
  height: "auto",
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  editBtnText: "客户资料",
  editTitle: "客户资料",
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: false,
  menu: true,
  indexLabel: "序号",
  selection: true,
  viewBtn: false,
  dialogType: "dialog",
  dialogClickModal: false,
  column: [
    {
      label: "资料名称",
      prop: "dataName",
      display: false,
      search:false,
    },
    {
      label: "资料份数",
      prop: "dataAmount",
      display: false,
    },
    {
      label: "订单编号",
      prop: "businessCode",
      display: false,
      search:true,
    },
    {
      label: "租赁人",
      prop: "name",
      type: "input",
      search: true,
      searchPlaceholder: "请输入租赁人",
      display: false,
    },
    {
      label: "所属代理商",
      prop: "businessDeptIdList",
      type: "select",
      filterable: true,
      multiple: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: "title",
        value: "id",
      },
    },
    {
      label: "车牌号",
      prop: "carFirstNumber",
      span: 24,
      search: false,
      display: false,
    },
    {
      label: "资料名称",
      prop: "mailingType",
      type: "select",
      filterable: true,
      multiple: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      hide: true,
      dicData: [{
        label:'备用钥匙',
        value: 0
      },{
        label:'登记证书',
        value: 1
      },{
        label:'驾照承诺函',
        value: 2
      },{
        label:'收款委托函',
        value: 3
      },{
        label:'担保人关系证明',
        value: 4
      },{
        label:'发票',
        value: 5
      },{
        label:'拍状元补充协议',
        value: 6
      },{
        label:'委托转款证明',
        value: 7
      },],
    },
    {
      label: "状态",
      prop: "mailingStatus",
      type:'select',
      span: 24,
      search: true,
      display: false,
      hide:true,
      dicData: [{
        label:'全部',
        value:''
      },{
        label:'已邮寄',
        value:0
      },{
        label:'未邮寄',
        value:1
      }],
    },
    {
      label: "id",
      prop: "id",
      display: false,
      hide: true,
    },
    {
      label: "状态",
      prop: "status",
      type:'select',
      span: 24,
      search: false,
      display: false,
      dicData: [{
        label:'已邮寄',
        value:0
      },{
        label:'未邮寄',
        value:1
      }],
    },
    {
      label: "所属代理商",
      prop: "businessDeptName",
      span: 24,
      display: false,
  }
  ],
  selectable:(row,index)=>{
    return row.status===1
  }
};
